
import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { BotUser } from "./models";

const getBotUsers = async (): Promise<BotUser[]> => {
    let config = getConfig();
    try {
        const response = await axios.get(`/admin/getBotUsers`, config);
        const data = response.data as BotUser[];
        return data;
    } catch (error) {
        return error as any
    }
};


const createBotUser = async ({ name, password }: { name: string, password: string }): Promise<BotUser | any> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/createBotUser`, { name, password }, config);

        return response.data as BotUser;
    } catch (error) {
        return error as any
    }
}


const updateBotUser = async ({ userName, newPassword, userId }: { userName: string, newPassword: string, userId: string }): Promise<BotUser | any> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/patchBotUser`, { userName, newPassword, userId }, config);
        return response.data as BotUser;
    } catch (error) {
        return error as any
    }
}

const deleteBotUser = async ({ userId }: { userId: string }): Promise<BotUser | any> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/deleteBotUser`, { userId }, config);
        return response.data as BotUser;
    } catch (error) {
        return error as any
    }
}

const toggleBlockedUser = async ({ userId, blocked }: { userId: string, blocked: boolean }): Promise<BotUser | any> => {
    let config = getConfig();
    try {
        const response = await axios.post(`/admin/toggleBlockUser`, { userId, blocked }, config);
        return response.data as BotUser;
    } catch (error) {
        return error as any
    }
}

export { getBotUsers, createBotUser, updateBotUser, deleteBotUser, toggleBlockedUser }